import { render } from "./EmailActionHandler.vue?vue&type=template&id=3765f946&scoped=true&ts=true"
import script from "./EmailActionHandler.vue?vue&type=script&lang=ts"
export * from "./EmailActionHandler.vue?vue&type=script&lang=ts"

import "./EmailActionHandler.vue?vue&type=style&index=0&id=3765f946&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3765f946"]])

export default __exports__